import createModel, { prop } from 'models/lib/create_model';

export const ChatTemplatedCard = createModel({
  modelName: 'ChatTemplatedCard',

  properties: {
    template: prop(String),
    data: prop().oneOf(String, Object, Array, Number, Boolean),
  },
});
